import axios from 'axios'
import { toast } from 'react-toastify';
import { commonMessage, statusCodes } from '../../../Constants/generalConfig';
import { promotionalAddonPlanList,promotionalAddonPlanStatusChange,promotionalAddonDelete,logOutApi } from '../../../Context/api';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const UsePromotionalAddOn = () => {
    const [messagePlanData, setMessagePlanData] = useState([])
    const [messagePlanId, setMessagePlanId] = useState('')
    const [filter, setFilter] = useState({
        status: 'true',
        planName:""
    })
    const [count, setCount] = useState(1)
    const [page, setPage] = useState(1)
    const [spinner, setSpinner] = useState(false)
    const PER_PAGE = 10
    const adminData = JSON.parse(localStorage.getItem('adminData'));
    const navigate = useNavigate()

    useEffect(() => {
        messagePlanListData();
        setSpinner(true)
    }, [page])

    const logOutFun = () => {
        axios.post(logOutApi(), { deviceId: adminData.deviceId, userId: adminData.userId, type: 'WEBADMIN' }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                localStorage.removeItem('adminData')
                navigate('/')
            }
        })
    }
    const messagePlanListData = () => {
        const data = {
            id: adminData.userId,
            isDeleted: false,
            isActive: filter.status === 'true',
            searchText: filter.planName,
            page: page,
            count: PER_PAGE
        }

        axios.post(promotionalAddonPlanList(), { ...data }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                setMessagePlanData(resp.data)
                setCount(resp.data.totalCount)
                setSpinner(false)
            }
            else if (resp.data.code === statusCodes.tokenExpire) {
                logOutFun()
            }
            else {
                setMessagePlanData([])
                setSpinner(false)
                if (page > 1) {
                    setPage(page - 1)
                }
            }
        })
            .catch(() => {
                toast.error(commonMessage.networkError)
                setSpinner(false)
            })
    }
    const deleteMessagePlan = () => {
        axios.post(promotionalAddonDelete(), { id: messagePlanId }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                toast.success(resp.data.message)
                messagePlanListData()
            }
            else if (resp.data.code === statusCodes.tokenExpire) {
                logOutFun()
            }
            else {
                toast.error(resp.data.message)
            }
        })
            .catch(() => {
                toast.error(commonMessage.networkError)
            })
    }
    const changeStatus = (item) => {
        setSpinner(true)
        axios.post(promotionalAddonPlanStatusChange(), { id: item._id, isActive: !item.isActive }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                toast.success(resp.data.message)
                filter.status = item.isActive.toString()
                setSpinner(false)
                messagePlanListData()
            }
            else if (resp.data.code === statusCodes.tokenExpire) {
                logOutFun()
            }
            else {
                toast.error(resp.data.message)
                setSpinner(false)
            }
        })
    }
    const handleChange = (e) => {
        const { name, value } = e.target
        setFilter((pre) => ({
            ...pre,
            [name]: value
        }))
    }
    return {
        setMessagePlanId,
        setCount,
        setPage,
        deleteMessagePlan,
        messagePlanListData,
        changeStatus,
        handleChange,
        filter,
        count,
        page,
        messagePlanData,
        spinner,
        PER_PAGE

    }
}

export default UsePromotionalAddOn